import { FC, InputHTMLAttributes, ReactElement } from 'react';
import classNames from '../../utils/classnames';
import { CatalogProps } from '../../utils/enhanced-ecommerce';
import { handleMouseDown } from '../../utils/material/material-helper';

type MaterialClickHandlerProps = InputHTMLAttributes<HTMLSpanElement> & {
    children: ReactElement | string;
    item: Material;
    materialProps: CatalogProps;
};

const MaterialClickHandler: FC<MaterialClickHandlerProps> = ({ children, ...props }) => {
    const { item, materialProps, className } = props;

    return (
        <span
            className={classNames('click-handler', className)}
            onMouseDown={() => handleMouseDown(item, materialProps)}
        >
            {children}
        </span>
    );
};

export default MaterialClickHandler;
